export default __webpack_public_path__ + "static/media/header.9a252f4a.jpg";